import { RootState } from '@/app/store.ts';
import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';

// Define a type for the slice state
export interface LoginState {
  email: string;
  password: string;
  errorInvalidCredentialVisible: boolean;
}

// Define the initial state using that type
const initialState: LoginState = {
  password: '',
  email: '',
  errorInvalidCredentialVisible: false,
};

export const loginSlice: Slice<LoginState> = createSlice({
  name: 'context',
  initialState,
  reducers: {
    setPassword: (state, action: PayloadAction<string>) => {
      state.errorInvalidCredentialVisible = false;
      state.password = action.payload;
    },

    setEmail: (state, action: PayloadAction<string>) => {
      state.errorInvalidCredentialVisible = false;
      state.email = action.payload;
    },
  },
});

export const { setPassword, setEmail, setErrorInvalidCredentialVisible } =
  loginSlice.actions;

export default loginSlice.reducer;

/**
 * getLoginState function
 *
 * @param state the root state
 * @returns     the state of the login
 */
export const getLoginState = (state: RootState) => state.login;
